import React from 'react';
import { FaLinkedinIn } from 'react-icons/fa';
import { contactImg } from '../../assets/index';

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[85%] h-auto bg-[#191b1e] bg-opacity-80 p-4 lgl:p-8 rounded-2xl shadow-shadowOne flex flex-col lgl:flex-row gap-8 justify-center items-center border border-gray-800 hover:border-r-designColor transition-colors duration-300 relative overflow-hidden">
      {/* Glow Effect */}
      <div className="absolute inset-0 bg-designColor/5 opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>

      <div className="w-full lgl:w-[35%] h-full overflow-hidden rounded-lg">
        <img
          className="w-full h-64 lgl:h-full object-cover rounded-lg mb-2 grayscale hover:grayscale-0 transition-grayscale duration-300 z-10"
          src={contactImg}
          alt="contactImg"
        />
      </div>
      <div className="w-full lgl:w-[60%] flex flex-col gap-4 z-10 items-start">
        <h3 className="text-3xl font-bold text-white font-titleFont">Aditya Raj</h3>
        <p className="text-lg font-normal text-designColor">Software Developer</p>
        <p className="text-base text-gray-400 tracking-wide font-bodyFont">
          I&apos;m Aditya Raj, a software developer and product builder focused on creating
          practical, user-first software. I work across the full product lifecycle—from shaping
          ideas and designing clean interfaces to building and scaling reliable systems. I&apos;m
          the founder of Retour, a real-time feedback platform that helps teams capture meaningful
          user input and turn it into clear, actionable insights. I value clean code, simple design,
          and thoughtful execution, and I aim to build products that solve real problems and deliver
          lasting value to users.
        </p>
        <div className="flex flex-col gap-2 mt-4">
          <p className="text-base text-gray-400 flex items-center gap-2">
            Phone:{' '}
            <span className="text-lightText hover:text-designColor cursor-pointer transition-colors duration-300">
              8797040159
            </span>
          </p>
          <p className="text-base text-gray-400 flex items-center gap-2">
            Email:{' '}
            <span className="text-lightText hover:text-designColor cursor-pointer transition-colors duration-300">
              adityarajfw39@gmail.com
            </span>
          </p>
        </div>
        <div className="flex flex-col gap-4 mt-6">
          <h2 className="text-base uppercase font-titleFont text-designColor tracking-widest">
            Find me in
          </h2>
          <div className="flex gap-4">
            <a href="https://www.linkedin.com/in/aditya-raj-programmer-analyst/" target="blank">
              <span className="bannerIcon hover:text-designColor hover:shadow-neon transition-all duration-300">
                <FaLinkedinIn />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
